// Reference scene timing: world, tour, measured event, measured surge, return, manual.
export const worldScene = () => ({
  mode: "world",
  code: null,
  count: null,
  distributed: false,
  step: 0,
  total: 0
});
export class MapSceneController {
  scene = worldScene();
  until = 0;
  lastTick = 0;
  index = -1;
  order = [];
  seen = null;
  lastSurge = null;
  pendingEvent = null;
  pendingSurge = null;
  eventCooldown = 0;
  surgeCooldown = 0;
  previous = null;
  supported;
  constructor(e) {
    this.supported = e;
  }
  sample(e, t) {
    let a = "tour" === this.scene.mode ? this.scene.code : this.order[this.index];
    this.order = (e?.countries ?? []).filter(e => e.count > 0 && "TR" !== e.code && this.supported(e.code)).sort((e, t) => t.count - e.count || e.code.localeCompare(t.code)).slice(0, 5).map(e => e.code), this.index = a ? this.order.indexOf(a) : -1;
    let l = null;
    if ("tour" !== this.scene.mode || this.order.includes(this.scene.code) || (this.scene = worldScene(), this.until = t + 1e4, l = this.scene), !e?.fresh) return this.pendingEvent = null, this.pendingSurge = null, l;
    let n = e.countries.filter(e => null !== e.recentCount && e.recentCount > 0).sort((e, t) => (t.recentCount ?? 0) - (e.recentCount ?? 0) || e.code.localeCompare(t.code))[0],
      r = e.recentBanTotal ?? 0;
    null !== e.recentBanTotal && n && (n.recentCount ?? 0) >= 20 && ((n.recentCount ?? 0) / Math.max(1, r) >= .4 || r >= 60) ? n.code !== this.lastSurge && this.supported(n.code) && "manual" !== this.scene.mode && (this.pendingSurge = {
      code: n.code,
      count: n.recentCount,
      distributed: n.recentCount / Math.max(1, r) < .4
    }) : (this.lastSurge = null, this.pendingSurge = null);
    let i = e.banTimeline.filter(e => Date.parse(e.at) >= t - 6e5 && Date.parse(e.at) <= t + 12e4),
      s = Math.max(0, ...i.map(e => Date.parse(e.at)));
    if (null !== this.seen && "manual" !== this.scene.mode) {
      let e = new Map();
      for (let t of i) {
        let a = Date.parse(t.at);
        if (a <= this.seen || !this.supported(t.code)) continue;
        let l = e.get(t.code) ?? {
          n: 0,
          at: 0
        };
        l.n += t.count, l.at = Math.max(l.at, a), e.set(t.code, l);
      }
      let t = [...e].sort((e, t) => t[1].n - e[1].n || t[1].at - e[1].at)[0];
      t && (this.pendingEvent = {
        code: t[0],
        count: t[1].n,
        distributed: !1
      });
    }
    return this.seen = Math.max(this.seen ?? 0, s), l;
  }
  reset(e, t = 1e4) {
    this.scene = worldScene(), this.until = e + t, this.previous = null, this.pendingEvent = null, this.pendingSurge = null, this.lastTick = e;
  }
  manual(e) {
    this.scene = {
      ...worldScene(),
      mode: "manual",
      code: e
    }, this.previous = null, this.pendingEvent = null, this.pendingSurge = null;
  }
  tick(e, t) {
    let a = this.lastTick ? Math.max(0, e - this.lastTick) : 0;
    if (this.lastTick = e, !t.visible || !t.motion || t.paused || !t.fresh) return this.until && (this.until += a), null;
    if ("manual" === this.scene.mode) return null;
    let l = t.phone ? 1700 : 1100,
      n = (t, a) => (this.previous || (this.previous = {
        scene: "event" === this.scene.mode ? worldScene() : {
          ...this.scene
        },
        left: Math.max(0, this.until - e)
      }), this.scene = {
        ...worldScene(),
        mode: t,
        code: a.code,
        count: a.count,
        distributed: a.distributed
      }, this.until = e + l + ("event" === t ? 8e3 : 1e4), "surge" === t && (this.lastSurge = a.code), this.scene);
    if (t.auto && this.pendingSurge && e >= this.surgeCooldown && ["world", "tour", "event"].includes(this.scene.mode)) {
      let e = this.pendingSurge;
      return this.pendingSurge = null, n("surge", e);
    }
    if (t.auto && this.pendingEvent && "world" === this.scene.mode && e >= Math.max(this.eventCooldown, this.surgeCooldown)) {
      let e = this.pendingEvent;
      return this.pendingEvent = null, n("event", e);
    }
    return this.until ? e < this.until ? null : "event" === this.scene.mode || "surge" === this.scene.mode ? ("event" === this.scene.mode ? this.eventCooldown = e + l + 25e3 : this.surgeCooldown = e + l + 45e3, this.scene = {
      ...(this.previous?.scene ?? worldScene()),
      mode: "return"
    }, this.until = e + l, this.scene) : "return" === this.scene.mode ? (this.scene = this.previous?.scene ?? worldScene(), "tour" !== this.scene.mode || this.order.includes(this.scene.code) || (this.scene = worldScene()), this.until = e + Math.max(1500, this.previous?.left ?? 1e4), this.previous = null, this.scene) : "tour" === this.scene.mode ? (this.scene = worldScene(), this.until = e + 1e4, this.scene) : t.tour && this.order.length ? (this.index = (this.index + 1) % this.order.length, this.scene = {
      ...worldScene(),
      mode: "tour",
      code: this.order[this.index],
      step: this.index + 1,
      total: this.order.length
    }, this.until = e + 7e3, this.scene) : (this.until = e + 1e4, null) : (this.until = e + 1e4, null);
  }
}
export function clampCamera(e, t) {
  let a = t ? {
      x: 350,
      y: -32,
      w: 960,
      h: 465
    } : {
      x: 0,
      y: 0,
      w: 1448,
      h: 350
    },
    l = Math.max(1, Math.min(2, e.k));
  return 1 === l ? {
    k: 1,
    x: 0,
    y: 0
  } : {
    k: l,
    x: Math.max(a.x + a.w - 1448 * l, Math.min(a.x - 350 * (t ? l : 0), e.x)),
    y: Math.max(a.y + a.h - 465 * l, Math.min(a.y + 32 * l, e.y))
  };
}

export function bezierPoint(start, control, end, t) {
  const u = 1 - t;
  return { x: u * u * start.x + 2 * u * t * control.x + t * t * end.x,
    y: u * u * start.y + 2 * u * t * control.y + t * t * end.y };
}

export function fitRouteCamera(start, control, end, phone) {
  const points = Array.from({ length: 65 }, (_, i) => bezierPoint(start, control, end, i / 64));
  const minX = Math.min(...points.map(p => p.x)), maxX = Math.max(...points.map(p => p.x));
  const minY = Math.min(...points.map(p => p.y)), maxY = Math.max(...points.map(p => p.y));
  const area = phone ? { x: 390, y: 8, w: 820, h: 315 } : { x: 435, y: 58, w: 650, h: 235 };
  const k = Math.max(1, Math.min(phone ? 1.5 : 1.65, (area.w - 90) / Math.max(80, maxX - minX), (area.h - 55) / Math.max(50, maxY - minY)));
  return clampCamera({ k, x: area.x + area.w / 2 - k * (minX + maxX) / 2,
    y: area.y + area.h / 2 - k * (minY + maxY) / 2 }, phone);
}

export function particlePlan(routes, target, phone, selected) {
  const plan = routes.slice(0, phone ? 13 : 21).map((route, rank) => {
    const distance = Math.hypot(route.point.x - target.x, route.point.y - target.y);
    const active = route.code === selected;
    return { code: route.code, rank, count: distance < 170 ? (active ? 5 : 4) : distance < 480 ? (active ? 10 : 9) : (active ? 20 : 16),
      duration: Math.max(1800, Math.min(3600, distance / 250 * 1000)) };
  });
  const total = plan.reduce((sum, item) => sum + item.count, 0), budget = phone ? 48 : 80;
  if (total <= budget) return plan;
  const spare = budget - 2 * plan.length, excess = total - 2 * plan.length;
  const scaled = plan.map(item => ({ ...item, count: 2 + Math.floor(spare * (item.count - 2) / excess), fraction: spare * (item.count - 2) / excess % 1 }));
  const remaining = budget - scaled.reduce((sum, item) => sum + item.count, 0);
  const ranked = [...scaled].sort((a, b) => b.fraction - a.fraction || a.rank - b.rank);
  for (let i = 0; i < remaining; i++) ranked[i].count++;
  return scaled.map(({ fraction, ...item }) => item);
}

// Equal-distance keyframes give every particle the reference's constant speed,
// including the fade at either end of the route. No random traffic is generated.
export function particleFrames(start, control, end) {
  const points = Array.from({ length: 101 }, (_, i) => bezierPoint(start, control, end, i / 100));
  const lengths = [0];
  for (let i = 1; i < points.length; i++) lengths.push(lengths[i - 1] + Math.hypot(points[i].x - points[i - 1].x, points[i].y - points[i - 1].y));
  const length = lengths[lengths.length - 1];
  let index = 1;
  return Array.from({ length: 33 }, (_, i) => {
    const distance = length * i / 32;
    while (index < lengths.length - 1 && lengths[index] < distance) index++;
    const segment = lengths[index] - lengths[index - 1], t = segment ? (distance - lengths[index - 1]) / segment : 0;
    const x = points[index - 1].x + (points[index].x - points[index - 1].x) * t;
    const y = points[index - 1].y + (points[index].y - points[index - 1].y) * t;
    return { offset: i / 32, transform: `translate(${x}px, ${y}px)`, opacity: i === 0 || i === 32 ? 0 : i === 1 || i === 31 ? .6 : 1 };
  });
}
